import React, { useEffect, useState } from 'react';

export default function ClientPreview() {
  const [frameScale, setScale] = useState(0.5);

  useEffect(() => {
    const loop = setInterval(() => {
      // 1920 x 1080 / 16x9
      let width_ratio = (100 * window.innerWidth) / 1920
      let height_ratio = (100 * window.innerHeight) / 1080
      if (width_ratio > height_ratio){
        // --
        setScale(window.innerHeight / 1080);
      }else{
        // ||
        setScale(window.innerWidth / 1920);
      }
    }, 500);
    return () => clearInterval(loop);
  }, []);
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', alignItems:'center', justifyContent: 'center', backgroundColor: '#000' }}>
      <iframe src="/" style={{ height: 1080, width: 1920, aspectRatio: '16/9', transform: `scale(${frameScale})` }} />
    </div>
  );
}
